import CloseIcon from '@mui/icons-material/Close';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Button,Dialog,DialogContent,DialogTitle,IconButton,Stack,Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { trackEventMatomo } from '../../../helpers/matomo';

type props = {
  openFinaliza: boolean,
  setOpenFinaliza: Function,
  mutate: Function,
  planoId: string,
};

export default function ModalFinalizaPA({
  openFinaliza,
  setOpenFinaliza,
  mutate,
  planoId, }: props) {
  const { t } = useTranslation('translation');
  return (
    <Dialog
      open={openFinaliza}
      onClose={() => setOpenFinaliza(false)}
      fullWidth
      maxWidth={'sm'}
      scroll={'paper'}
    >
      <DialogTitle>{t('ActionPlan.Modal.finishActionPlan')}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpenFinaliza(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <Stack direction='row' justifyContent='center' alignItems='center' spacing={2} padding={2}>
          <Typography color='textDisabled' fontWeight={600}>{t('ActionPlan.Modal.confirmFinishActionPlan')}</Typography>
          <Button
            endIcon={<TaskAltIcon />}
            variant='contained'
            color='success'
            onClick={() => {
              trackEventMatomo('modal finaliza PA', 'click', 'button', 'salva');
              mutate(planoId);
            }}
          >{t('ActionPlan.Modal.finishPlan')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
